const audioClipUrl = '/audio-clip';

export default audioClipUrl;
